module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "notFound"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": "/static/img/logo.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center col-sm-12"
  }, [_c('h1', [_vm._v("You are lost.")]), _vm._v(" "), _c('h4', [_vm._v("This page doesn't exist.")]), _vm._v(" "), _c('router-link', {
    staticClass: "vertical-5p lead",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Take me home.")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e71a53b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/404.vue
// module id = 634
// module chunks = 1